import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer
        className={
          "footer" +
          (this.props.transparent !== undefined ? " footer-transparent" : "")
        }
      >
        <div
          className={
            "container" + (this.props.fluid !== undefined ? "-fluid" : "")
          }
        >
          <p className="copyright text-center">
            &copy; {1900 + new Date().getYear()}{" "}
            <a href="https://gvccracing.com">GVCC</a>, made with{" "}
            <i className="fa fa-heart heart" /> for{" "}
            <i className="fa fa-bicycle" />
          </p>
        </div>
      </footer>
    );
  }
}
export default Footer;
